import type { GameEvent } from '../api/games';
import styles from './LiveEventFeed.module.css';

const EVENT_LABELS: Partial<Record<string, string>> = {
  join: 'joined',
  leave: 'left',
  kick: 'kicked',
  start: 'game started',
  end: 'game over',
  restart: 'new round',
  kill_request: 'kill attempt →',
  kill_accept: 'kill confirmed →',
  kill_decline: 'kill declined →',
  kill: 'eliminated →',
  arrest: 'arrested',
  witness_report: 'report filed →',
  witness_response: 'report response',
  mod_ruling: 'ruling made',
  weapon_suggest: 'weapon suggested',
  weapon_approve: 'weapon approved',
  weapon_decline: 'weapon declined',
};

function formatTime(iso: string) {
  const d = new Date(iso);
  return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}

type Props = {
  events: GameEvent[];
};

export function LiveEventFeed({ events }: Props) {
  if (events.length === 0) return null;

  return (
    <div className={styles.feed}>
      <p className={styles.heading}>Live events</p>
      {events.map((e, i) => (
        <div key={i} className={styles.row}>
          <span className={styles.time}>{formatTime(e.happened_at)}</span>
          <span className={styles.actor}>{e.actor ?? '—'}</span>
          <span className={styles.verb}>{EVENT_LABELS[e.type] ?? e.type}</span>
          {e.target && <span className={styles.target}>{e.target}</span>}
        </div>
      ))}
    </div>
  );
}
